<template>
  <a
    v-if="$slots.default"
    class="icon-link"
    :class="{
      'text-right': iconPlacement === 'right',
      'icon-link--secondary': type === 'secondary',
      'icon-link--primary': type === 'primary',
      'icon-link--positive': type === 'positive',
      'icon-link--negative': type === 'negative'
    }"
    v-on="$listeners"
  >
    <icon
      v-if="icon && iconPlacement === 'left'"
      :icon="icon"
      class="w-6 h-6 align-middle"
      :class="iconClasses"
    />
    <span class="underline">
      <slot />
    </span>
    <icon
      v-if="icon && iconPlacement === 'right'"
      :icon="icon"
      class="w-6 h-6 align-middle"
      :class="iconClasses"
    />
  </a>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: ""
    },
    iconPlacement: {
      type: String,
      default: "left",
      validator(value) {
        return ["left", "right"].indexOf(value) !== -1;
      }
    },
    type: {
      type: String,
      default: "primary",
      validator(value) {
        return (
          ["primary", "secondary", "positive", "negative"].indexOf(value) !== -1
        );
      }
    }
  },
  computed: {
    iconClasses() {
      return {
        "icons-primary": this.type === "primary",
        "icons-secondary": this.type === "secondary",
        "icons-positive": this.type === "positive",
        "icons-negative": this.type === "negative"
      };
    }
  }
};
</script>

<style>
.icon-link {
  @apply text-xs font-bold text-primary-700 no-underline;
  transition: all 0.2s ease-in-out;
}

.icon-link:hover {
  @apply text-primary-900;
}

.icon-link--primary {
  @apply text-primary-700;
}

.icon-link--primary:hover {
  @apply text-primary-900;
}

.icon-link--secondary {
  @apply text-secondary-700;
}

.icon-link--secondary:hover {
  @apply text-secondary-900;
}

.icon-link--negative {
  @apply text-negative-600;
}

.icon-link--negative:hover {
  @apply text-negative-900;
}
</style>
